import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import { setupGlobalFetchAuthInterceptor } from './utils/setupGlobalFetchAuth';
import { registerServiceWorker } from './serviceWorkerRegistration';
import { ThemeProvider } from './theme/ThemeContext';

setupGlobalFetchAuthInterceptor();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Failed to find the root element");
}
const root = ReactDOM.createRoot(rootElement);
root.render(
  <ThemeProvider>
    <App />
  </ThemeProvider>
);

registerServiceWorker();
reportWebVitals();
